import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { style: {"display":"flex","justify-content":"center","margin-top":"20px","margin-bottom":"20px"} }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Submit")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_page_header = _resolveComponent("el-page-header")!
  const _component_el_descriptions_item = _resolveComponent("el-descriptions-item")!
  const _component_el_descriptions = _resolveComponent("el-descriptions")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_card = _resolveComponent("el-card")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.isEdit === false)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_el_page_header, {
            content: "Add New Account",
            onBack: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.go(-1))),
            style: {"margin-top":"-25px","margin-bottom":"15px"}
          })
        ]))
      : _createCommentVNode("", true),
    (_ctx.isEdit === true)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_el_page_header, {
            content: "Edit Account",
            onBack: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.go(-1))),
            style: {"margin-top":"-25px","margin-bottom":"15px"}
          })
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_el_card, { class: "box-card" }, {
      default: _withCtx(() => [
        _createVNode(_component_el_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, { span: 24 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_descriptions, {
                  style: {"float":"right"},
                  column: "1"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_descriptions_item, { label: "Available Balance" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString((_ctx.isEdit && _ctx.accountRef )? _ctx.accountRef.availableBalance : 0.00) + " " + _toDisplayString(' ' + _ctx.accountForm.currency), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_descriptions_item, { label: "Unavailable Balance" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString((_ctx.isEdit && _ctx.accountRef ) ? _ctx.accountRef.unavailableBalance : 0.00) + _toDisplayString(' ' + _ctx.accountForm.currency), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, { span: 24 }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, [
                  _withDirectives((_openBlock(), _createBlock(_component_el_form, {
                    ref: "formRef",
                    model: _ctx.accountForm,
                    "label-width": "200px",
                    style: {"width":"100%"},
                    rules: _ctx.rules
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_form_item, {
                        label: "Account Type",
                        required: "",
                        prop: "type"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            modelValue: _ctx.accountForm.type,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.accountForm.type) = $event)),
                            placeholder: "please select a type",
                            style: {"width":"50%"},
                            disabled: _ctx.isEdit
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_option, {
                                label: "Bank",
                                value: "Bank"
                              }),
                              _createVNode(_component_el_option, {
                                label: "Channel Fiat",
                                value: "ChannelFiat"
                              }),
                              _createVNode(_component_el_option, {
                                label: "Channel DigitalWallet",
                                value: "ChannelCrypto"
                              })
                            ]),
                            _: 1
                          }, 8, ["modelValue", "disabled"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        label: "Country",
                        required: "",
                        prop: "country"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            modelValue: _ctx.accountForm.country,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.accountForm.country) = $event)),
                            placeholder: "please select a country",
                            style: {"width":"50%"},
                            filterable: ""
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.countries, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item,
                                  label: item.name,
                                  value: item.code
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        label: "Currency",
                        required: "",
                        prop: "currency"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            modelValue: _ctx.accountForm.currency,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.accountForm.currency) = $event)),
                            placeholder: "please select a currency",
                            style: {"width":"50%"},
                            disabled: _ctx.isEdit
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currencies, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item,
                                  label: item.name,
                                  value: item.code
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue", "disabled"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        label: "Source",
                        required: "",
                        prop: "sourceId",
                        rules: [{ required: true, message: 'source is required', trigger: 'blur' }]
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            modelValue: _ctx.accountForm.sourceId,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.accountForm.sourceId) = $event)),
                            placeholder: "please select a source",
                            style: {"width":"50%"},
                            disabled: _ctx.isEdit
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.accountSourcesRef, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item,
                                  label: item.name,
                                  value: item.id
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue", "disabled"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        label: _ctx.accountForm.type === 'ChannelCrypto' ? 'Wallet address':'Account No.',
                        required: "",
                        prop: "accountNumber"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.accountForm.accountNumber,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.accountForm.accountNumber) = $event)),
                            style: {"width":"50%"}
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }, 8, ["label"]),
                      _createVNode(_component_el_form_item, {
                        label: "Account Name",
                        required: "",
                        prop: "accountName"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.accountForm.accountName,
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.accountForm.accountName) = $event)),
                            style: {"width":"50%"}
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      (_ctx.accountForm.country === 'CN' && _ctx.accountForm.type === 'Bank')
                        ? (_openBlock(), _createBlock(_component_el_form_item, {
                            key: 0,
                            label: "CNAPS Code",
                            required: "",
                            prop: "cnapsCode"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                modelValue: _ctx.accountForm.cnapsCode,
                                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.accountForm.cnapsCode) = $event)),
                                style: {"width":"50%"}
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (_ctx.accountForm.country === 'CN' && _ctx.accountForm.type === 'Bank')
                        ? (_openBlock(), _createBlock(_component_el_form_item, {
                            key: 1,
                            label: "UKey Expiration Date",
                            prop: "ukeyExpiryDate"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_date_picker, {
                                modelValue: _ctx.accountForm.ukeyExpiryDate,
                                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.accountForm.ukeyExpiryDate) = $event)),
                                type: "date",
                                placeholder: "Pick a day",
                                style: {"width":"50%"}
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (_ctx.accountForm.type === 'Bank'  &&  _ctx.accountForm.country)
                        ? (_openBlock(), _createBlock(_component_el_form_item, {
                            key: 2,
                            label: "Swift Code",
                            required: "",
                            prop: "swiftCode"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                modelValue: _ctx.accountForm.swiftCode,
                                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.accountForm.swiftCode) = $event)),
                                style: {"width":"50%"}
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (_ctx.accountForm.type === 'Bank' && _ctx.accountForm.currency === 'USD')
                        ? (_openBlock(), _createBlock(_component_el_form_item, {
                            key: 3,
                            label: "ACH Code (9-digit)",
                            prop: "routingCode1"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                modelValue: _ctx.accountForm.routingCode1,
                                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.accountForm.routingCode1) = $event)),
                                style: {"width":"50%"}
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (_ctx.accountForm.type === 'Bank' && _ctx.accountForm.currency === 'AUD')
                        ? (_openBlock(), _createBlock(_component_el_form_item, {
                            key: 4,
                            label: "BSB Number (6-digit)",
                            prop: "routingCode1"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                modelValue: _ctx.accountForm.routingCode1,
                                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.accountForm.routingCode1) = $event)),
                                style: {"width":"50%"}
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (_ctx.accountForm.type === 'Bank' && _ctx.accountForm.currency === 'GBP')
                        ? (_openBlock(), _createBlock(_component_el_form_item, {
                            key: 5,
                            label: "Sort Code (6-digit)",
                            prop: "routingCode1"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                modelValue: _ctx.accountForm.routingCode1,
                                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.accountForm.routingCode1) = $event)),
                                style: {"width":"50%"}
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (_ctx.accountForm.type === 'Bank' && _ctx.accountForm.currency === 'INR')
                        ? (_openBlock(), _createBlock(_component_el_form_item, {
                            key: 6,
                            label: "IFSC Code (11-digit)",
                            prop: "routingCode1"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                modelValue: _ctx.accountForm.routingCode1,
                                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.accountForm.routingCode1) = $event)),
                                style: {"width":"50%"}
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (_ctx.accountForm.type === 'Bank' && _ctx.accountForm.currency === 'JPY')
                        ? (_openBlock(), _createBlock(_component_el_form_item, {
                            key: 7,
                            label: "Bank Code (4-digit)",
                            prop: "routingCode1"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                modelValue: _ctx.accountForm.routingCode1,
                                "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.accountForm.routingCode1) = $event)),
                                style: {"width":"50%"}
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (_ctx.accountForm.type === 'Bank' && _ctx.accountForm.currency === 'CAD')
                        ? (_openBlock(), _createBlock(_component_el_form_item, {
                            key: 8,
                            label: "Transit Code (5-digit)",
                            prop: "routingCode1"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                modelValue: _ctx.accountForm.routingCode1,
                                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.accountForm.routingCode1) = $event)),
                                style: {"width":"50%"}
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (_ctx.accountForm.type === 'Bank' && _ctx.accountForm.currency === 'CAD')
                        ? (_openBlock(), _createBlock(_component_el_form_item, {
                            key: 9,
                            label: "Institution Code (3-digit)",
                            prop: "routingCode2"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                modelValue: _ctx.accountForm.routingCode2,
                                "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.accountForm.routingCode2) = $event)),
                                style: {"width":"50%"}
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (_ctx.accountForm.type === 'Bank')
                        ? (_openBlock(), _createBlock(_component_el_form_item, {
                            key: 10,
                            label: "Branch",
                            required: "",
                            prop: "branch"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                modelValue: _ctx.accountForm.branch,
                                "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.accountForm.branch) = $event)),
                                style: {"width":"50%"}
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (_ctx.accountForm.type === 'Bank')
                        ? (_openBlock(), _createBlock(_component_el_form_item, {
                            key: 11,
                            label: "Branch Address",
                            required: "",
                            prop: "branchAddress"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                modelValue: _ctx.accountForm.branchAddress,
                                "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.accountForm.branchAddress) = $event)),
                                style: {"width":"50%"}
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (_ctx.accountForm.type === 'ChannelCrypto')
                        ? (_openBlock(), _createBlock(_component_el_form_item, {
                            key: 12,
                            label: "Network",
                            required: "",
                            prop: "cryptoNetwork"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                modelValue: _ctx.accountForm.cryptoNetwork,
                                "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.accountForm.cryptoNetwork) = $event)),
                                style: {"width":"50%"}
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      _createVNode(_component_el_form_item, {
                        label: "Status",
                        required: "",
                        prop: "status"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_switch, {
                            modelValue: _ctx.accountForm.status,
                            "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.accountForm.status) = $event)),
                            class: "mb-2",
                            "active-text": "",
                            "inactive-text": ""
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        label: "Description",
                        required: "",
                        prop: "description"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.accountForm.description,
                            "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.accountForm.description) = $event)),
                            rows: 2,
                            type: "textarea",
                            style: {"width":"50%"},
                            placeholder: "Please input description"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        label: "Comment",
                        prop: "remarks"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.accountForm.remarks,
                            "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.accountForm.remarks) = $event)),
                            rows: 2,
                            type: "textarea",
                            style: {"width":"50%"},
                            placeholder: "Please input"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_button, {
                            type: "primary",
                            onClick: _ctx.onSubmit
                          }, {
                            default: _withCtx(() => [
                              _hoisted_4
                            ]),
                            _: 1
                          }, 8, ["onClick"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["model", "rules"])), [
                    [_directive_loading, _ctx.loadingRef]
                  ])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}